<template>
  <nuttrema-layout-content>

    <template slot="overflow">
      <page-help
         v-if="show.pageHelp"
         file="participants"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>
    </template>

    <nuttrema-list-control
       slot="header"
      :meta="PersonsList.meta"
      @search="doSearch">
      <template slot="left">
        <div class="nav-item is-with-sup">
          <h5 class="nav-item--sup-title">{{ $t('label.persons') }}</h5>
          <h4 class="nav-item--title">{{ $t('label.participants') }}</h4>
        </div>
      </template>
      <template slot="right">
        <div class="nav-item">
          <el-button type="primary" :plain="true" size="mini" class="is-icon" @click="show.pageHelp = true">
            <i class="far fa-question"></i>
            <span>{{ $t('label.help') }}</span>
          </el-button>
        </div>
      </template>
    </nuttrema-list-control>

    <participants-index-list
       slot="central"
      :meta="meta"
      :params="params"
      :state="PersonsList"
      :showFilters="showFilters"
      :propCurrentPage="params.page"
      :propPageSize="params.per_page"
      @changeOrder="doChangeOrder"
      @changeSortBy="doChangeSortBy"
      @changeGroupBy="doChangeGroupBy"
      @currentPageChange="doPageChange"
      @filterByOrigin="doFilterByOrigin"
      @pageSizeChange="doPageSizeChange"
      @filterByFirstLetter="doFilterByFirstLetter">
    </participants-index-list>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
import * as EVENT from 'constants/event';
import { PERSON_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';
import ServerSidePageList from 'components/mixins/server-side-page-list';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import NuttremaMenubar from 'components/ui/panels/nuttrema-menubar';
import NuttremaListControl from 'components/ui/panels/nuttrema-list-control';

import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';
import ParticipantsIndexList from './cmpt-participants-index-list';

export default {
  name: 'page-participants-list',
  componentName: 'PageParticipantsList',
  mixins: [
    PageProps,
    ServerSidePageList,
  ],
  components: {
    PageHelp,
    NuttremaMenubar,
    NuttremaListControl,
    NuttremaLayoutContent,
    ParticipantsIndexList,
  },
  data() {
    return {
      show: {
        pageHelp: false,
      },
      search: '',
      filterByOrigin: '',
      filterByFirstLetter: '',
      type: PERSON_KEYS.participant,
      localStorageKey: 'participants_list',
      paramsDefault: {
        include: 'picture,current_program',
      },
      // group_by: '',
    };
  },
  computed: {
    PersonsList() {
      return this.$store.getters.PersonsList(this.type);
    },
  },
  methods: {
    fetch() {
      this.$store.dispatch('GetPersonsList', { type: this.type, query: this.params });
    },
    clean() {
      this.$store.dispatch('ClearPersonsList', { type: this.type });
    },
  },
  created() {
    this.$on(EVENT.SHOW_PAGE_HELP, (name) => {
      if (this.componentName === name) this.show.pageHelp = true;
    });
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/list/page-participants-list.vue